import { getLorryDetailsByType, LORRY_CAPACITY_UNIT_TYPES } from "@vahak/core/dist/constants";

export const getLorryCapacityUnitLabel = (lorryTypeId?: number, quantity?: number) => {
    const lorryInfo = getLorryDetailsByType(lorryTypeId);

    if (lorryInfo?.unit === LORRY_CAPACITY_UNIT_TYPES.TONNES) {
        return quantity === 1 ? "Tonne" : "Tonnes";
    }

    return lorryInfo?.unitSingular || "Tonne";
};
